import numeral from "numeral"
import { canUseNumeral } from "../../../utils/numerals"
import { SERIE_FORMAT } from "./ChartOptions"
import type { FormatterOptions } from "./sharedFormatter"
import * as sharedFormatters from "./sharedFormatter"
import type { Highcharts } from "./useHighcharts"

const pricingFormatter = function pricingFormatter() {
  return (value: number) => {
    const numValue = Number(value)
    if (numValue === 0) {
      return "$0"
    }

    if (canUseNumeral(numValue) && numValue < 10) {
      return numeral(value).format("$0[.]0[0000]a")
    }

    return sharedFormatters.pricingFormatter(value, "$0[.]0a")
  }
}

const percentageFormatter = function percentageFormatter({
  isPercentageShare,
}: FormatterOptions) {
  return (value: number) => {
    let numValue = Number(value)
    if (!isPercentageShare) {
      numValue = numValue * 100
    }

    return sharedFormatters.percentageFormatter(numValue)
  }
}

const ratioFormatter = function ratioFormatter() {
  return (value: number) => sharedFormatters.ratioFormatter(value)
}

const numberFormatter = function numberFormatter() {
  return (value: number) => sharedFormatters.numberFormatter(value)
}

const timeFormatter = function timeFormatter() {
  return (value: number) => sharedFormatters.timeFormatter(value)
}

const bytesFormatter = function bytesFormatter() {
  return (value: number) => sharedFormatters.bytesFormatter(value)
}

const formatters = {
  [SERIE_FORMAT.PRICE]: pricingFormatter,
  [SERIE_FORMAT.RATIO]: ratioFormatter,
  [SERIE_FORMAT.PERCENTAGE]: percentageFormatter,
  [SERIE_FORMAT.NUMBER]: numberFormatter,
  [SERIE_FORMAT.TOKEN]: numberFormatter,
  [SERIE_FORMAT.TIME]: timeFormatter,
  [SERIE_FORMAT.BYTES]: bytesFormatter,
  [SERIE_FORMAT.TOKEN_ICP]: numberFormatter,
  [SERIE_FORMAT.TOKEN_CKBTC]: numberFormatter,
  [SERIE_FORMAT.TOKEN_CKETH]: numberFormatter,
  [SERIE_FORMAT.CYCLES_PER_SECONDS]: numberFormatter,
  [SERIE_FORMAT.KWH]: numberFormatter,
} as const

/** @deprecated */
export const getAxisFormatter = (
  serie: `${SERIE_FORMAT}`,
  options: FormatterOptions = {}
): Highcharts.AxisLabelsFormatterCallbackFunction => {
  const formatter = formatters[serie](options)
  return function () {
    const value = Number(this.value)
    return formatter(value)
  }
}
